<template>
  <v-container class="grid-container">
    <v-row>
      <v-col cols="12" md="4" v-for="page of topRow" :key="page.title">
        <v-card
          outlined
          class="pa-10 d-flex align-center justify-center"
          @click="$router.push({ name: page.nav })">
          <div>
            <div class="d-flex justify-center mb-6">
              <v-icon
                style="font-size: 60px; height: 60px; width: 60px;"
                v-text="page.icon"
                color="grey" />
            </div>
            <h6
              class="text-h6 font-weight-light grey--text text-center mb-0"
              v-html="page.title" />
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="4" :offset-md="index < 1 ? 2 : 0"
        v-for="(page, index) of bottomRow" :key="page.title">
        <v-card
          outlined
          class="pa-10 d-flex align-center justify-center"
          @click="$router.push({ name: page.nav })">
          <div>
            <div class="d-flex justify-center mb-6">
              <v-icon
                style="font-size: 60px; height: 60px; width: 60px;"
                v-text="page.icon"
                color="grey" />
            </div>
            <h6
              class="text-h6 font-weight-light grey--text text-center mb-0"
              v-html="page.title" />
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  mdiCrownOutline,
  mdiAbacus,
  mdiStrategy,
  mdiSwordCross,
  mdiShieldHalfFull
} from '@mdi/js';

export default {
  name: 'landing',
  data() {
    return {
      topRow: [
        { title: 'Penetration Testing Plays', nav: 'plays', icon: mdiCrownOutline },
        { title: 'CAPEC&trade;', nav: 'capecs', icon: mdiAbacus },
        { title: 'MITRE ATT&amp;CK&reg;', nav: 'techniques', icon: mdiStrategy }
      ],
      bottomRow: [
        { title: 'NIST SP 800-53 (Rev. 5)', nav: 'controls', icon: mdiSwordCross },
        { title: 'CWE&trade;', nav: 'cwes', icon: mdiShieldHalfFull }
      ]
    }
  }
};
</script>

<style>
.grid-container {
  padding-top: 12vh;
  width: 72vw;
  min-height: 80vh;
}
@media screen and (max-width: 800px) {
  .grid-container {
    padding-top: unset !important;
  }
}
.callout {
  margin: 2%;
}

.v-icon svg {
  height: 60px;
  width: 60px;
}
</style>
